import { AttributeInterface } from '../../../core/interfaces/product/product';
import { RedisProviderCategoryAttributeRootInterface } from '../../../core/interfaces/categories/provider-category-attributes-interface';

export function providerAttributeEditFunction(
  providerProductAttributes: AttributeInterface[],
  providerCategoryAttributes: RedisProviderCategoryAttributeRootInterface[]
) {
  providerProductAttributes.map((attribute) => {
    if (attribute.Value.length > 0) {
      const finedAttribute = providerCategoryAttributes.find(
        (f) => f.Code === attribute.Code
      );

      const found = attribute.Values.find((f) => f.Key === 'magentyKey');
      if (
        !found &&
        finedAttribute &&
        finedAttribute.Editable &&
        finedAttribute.Values.length > 0
      ) {
        const lowerCaseOldValue = attribute.Value.toLocaleLowerCase();
        const matchingValue = finedAttribute.Values.find(
          (value) => value.Value.toLocaleLowerCase() === lowerCaseOldValue
        );
        const isEdited = !matchingValue;

        if (finedAttribute.Edited !== undefined) {
          finedAttribute.Edited = !matchingValue;

          if (isEdited) {
            finedAttribute.Values.push({
              Key: 'magentyKey',
              Value: attribute.Value,
              lowercaseValue: attribute.Value.toLocaleLowerCase(),
            });
          }
        }
      }
    }
  });

  return providerProductAttributes;
}
